import CustomButton from '../../ui/CustomButton';
import PopupButton from './PopupButton';
import Search from './Search';
import styles from './Banner.module.scss';
import { useSession } from '../../../lib/hooks';
const Banner = ({
  header,
  subHeader,
  description,
  background = '#014ca1',
  customCSS,
  imageURL,
  imagePosition,
  action,
  search,
  popupButton
}) => {
  const {
    name
  } = useSession().user;
  return <section className={styles['dynamic-banner-container']} data-sentry-component="Banner" data-sentry-source-file="Banner.jsx">
      <div className={styles['welcome-message']}>
        <span className={styles['welcome-text']}>Welcome, {name}</span>
      </div>
      <div className={styles['background-banner']} style={{
      background,
      ...customCSS
    }} />
      <div className={styles['banner-content']}>
        <div className={styles['banner-header']}>
          <header children={header} />
          <i children={subHeader} />
        </div>
        <div className={styles['banner-text']} children={description} />
        <div style={{
        maxWidth: '300px'
      }}>
          {search && <Search {...search} size="large" />}
          {action && <CustomButton {...action} displayInaccessible title={action.title || action.page.name || action.name} url={{
          pathname: `/toolkits/${action.page.type}/[slug]`,
          query: {
            slug: action.page.slug
          }
        }} />}
          {popupButton && <PopupButton {...popupButton} />}
        </div>
      </div>
      <div className={`${styles['hero-image']} ${styles[imagePosition]}`} children={imageURL && <img src={imageURL} alt="hero image" />} />
    </section>;
};
export default Banner;